import { useState } from "react";
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "../styles/intro-gallery.css";

const images = [
  "/images/intro-banner/01.webp",
  "/images/intro-banner/02.webp",
  "/images/intro-banner/03.webp",
  "/images/intro-banner/04.webp",
  "/images/intro-banner/05.webp",
  "/images/intro-banner/06.webp",
  "/images/intro-banner/07.webp",
  "/images/intro-banner/08.webp",
  "/images/intro-banner/09.webp",
];

const IntroBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openLightbox = (index) => setCurrentIndex(index);
  const closeLightbox = () => setCurrentIndex(null);
  const showPrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1));
  };
  const showNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  };

  return (
    <section className="intro-banner">
      <div className="intro-banner-title">
        <h1 className="main-title">Cần Thơ Khởi Nghiệp Đổi Mới Sáng Tạo</h1>
        <p className="sub-title">Thời đại công nghệ số & trí tuệ nhân tạo</p>
      </div>

      <div className="intro-banner-grid">
        {images.map((img, i) => (
          <div
            key={i}
            className="intro-banner-item"
            onClick={() => openLightbox(i)}
          >
            <img
              src={img}
              alt={`Banner ${i + 1}`}
            />
          </div>
        ))}
      </div>

      {currentIndex !== null && (
        <div
          className="intro-banner-lightbox"
          onClick={closeLightbox}
        >
          <button
            className="close"
            onClick={closeLightbox}
          >
            <FaTimes />
          </button>
          <button
            className="prev"
            onClick={showPrev}
          >
            <FaChevronLeft />
          </button>
          <img
            src={images[currentIndex]}
            alt={`Preview ${currentIndex + 1}`}
          />
          <button
            className="next"
            onClick={showNext}
          >
            <FaChevronRight />
          </button>
        </div>
      )}
    </section>
  );
};

export default IntroBanner;
